import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 27,
	viewBox: "0 0 28 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.74532 26.2641H26.5926V3.58874H0.74532V26.2641ZM26.966 27H0.373302C0.166923 27 0 26.8423 0 26.6323V3.20727C0 3.01009 0.166923 2.8396 0.373302 2.8396H26.966C27.1723 2.8396 27.338 3.01009 27.338 3.20727V26.6323C27.338 26.8423 27.1723 27 26.966 27Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.4038 5.58673C20.1987 5.58673 20.0317 5.41572 20.0317 5.21854V0.368239C20.0317 0.171062 20.1987 4.00543e-05 20.4038 4.00543e-05C20.6088 4.00543e-05 20.7757 0.171062 20.7757 0.368239V5.21854C20.7757 5.41572 20.6088 5.58673 20.4038 5.58673Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.74357 5.58673C6.5385 5.58673 6.37158 5.41572 6.37158 5.21854V0.368239C6.37158 0.171062 6.5385 4.00543e-05 6.74357 4.00543e-05C6.95126 4.00543e-05 7.11822 0.171062 7.11822 0.368239V5.21854C7.11822 5.41572 6.95126 5.58673 6.74357 5.58673Z",
			fill: "#272525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9662 7.26941H0.643014C0.43795 7.26941 0.270996 7.09839 0.270996 6.88846C0.270996 6.69076 0.43795 6.52027 0.643014 6.52027H26.9662C27.1726 6.52027 27.3382 6.69076 27.3382 6.88846C27.3382 7.09839 27.1726 7.26941 26.9662 7.26941Z",
			fill: "#272525"
		})
	]
});
export { SvgCalendar as ReactComponent };
